import { useDeviceClass } from "@/shared/hooks/useDeviceClass";
import LoginDesktopView from "@/pages/authentication/views/LoginDesktopView";
import LoginMobileView from "@/pages/authentication/views/LoginMobileView";

export default function LoginPage() {
    const device = useDeviceClass();
    return device === "mobile" ? <LoginMobileView /> : <LoginDesktopView />;
}
